import React from "react";
import { LoginForm } from "../../components/Login/Login";
import { SpinnerLoading } from "../../components/shared/Spinner/SpinnerLoading";
import { isProviderUniversalLogoutInProgress } from "../../auth/providerUniversalLogin";
import {
  ProviderAuthShell,
  ProviderAuthSpinnerWrapper,
} from "../../auth/ProviderAuthShell";

const Login = (): React.ReactElement => {
  if (isProviderUniversalLogoutInProgress()) {
    return (
      <ProviderAuthShell
        title="Signing you out"
        description="You'll return to the sign-in page in a moment."
      >
        <ProviderAuthSpinnerWrapper>
          <SpinnerLoading />
        </ProviderAuthSpinnerWrapper>
      </ProviderAuthShell>
    );
  }

  return <LoginForm />;
};

export default Login;
